export const EMAIL_MANAGEMENT_DEFAULT_QUERY = {
  _pagina: '1',
  _num_x_pagina: '5',
  // black: 'true',
  // white: 'true',
}

export const EMAIL_MANAGEMENT_FILTERS = [
  {
    name: 'black',
    filterType: 'switch',
    label: 'Mostrar solo Blacklist activos',
  },
  {
    name: 'white',
    filterType: 'switch',
    label: 'Mostrar solo Whitelist activos',
  },
]
